import _ from 'lodash';
import {Model, ARRAY_SHAPE, DOCUMENT_SHAPE} from 'vias';
import http from 'sp-components/util/http';
import {routes, url} from 'oo-routes';

export default new Model('Pricing', {
  id: '_id',
}, {
  get: function (alias, key, options, cb) {
    http.get(url('query', routes.query.data.pricing.detail, {pricingId: key}), cb);
  },
},{
  searchByName: {
    shape: DOCUMENT_SHAPE,
    action(data, options, cb) {
      http.get(url('query', routes.query.data.pricing.detail, {identifier: data}), cb);
    },
  },
  getAll: {
    shape: ARRAY_SHAPE,
    action(data, options, cb) {
      http.get(url('query', routes.query.data.pricing.base), cb);
    },
  },
});



// WEBPACK FOOTER //
// ./~/sp-components/models/Pricing.js